<app-alerts />

<app-admin-dictionary-country-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)" />
